
import {bus} from './index'
const eventMap = {}
export default {
  data(){
    return {
    }
  },
  methods: {
    $busOn(event, callback){
      
      eventMap[this._uid][event] = eventMap[this._uid][event] || []
      eventMap[this._uid][event].push(callback);
      bus.$on(event, callback);
    }
  },
  created(){
    eventMap[this._uid] = eventMap[this._uid] || {}
  },
  beforeDestroy(){
    for(let event in eventMap[this._uid]){
      for(let func of eventMap[this._uid][event]){
        bus.$off(event,func);
      }
    }
    delete eventMap[this._uid];
    
  },
  components: {
  }
}
